/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { GetSalesforceDataService } from 'app/services/salesforce-data';
import { FetchData } from 'app/shared/generalMethods';

@Component({
  selector: 'app-programs-list',
  templateUrl: './programs-list.component.html',
  styleUrls: ['./programs-list.component.scss']
})
export class ProgramsListComponent implements OnInit {
  userRecord: any;
  dataSource: any[] = [];
  parentId: string | null = null;
  allowProgramCreation: boolean = false;
  isAdmin: boolean = false;
  permissions: any = {
    programs: {
      view: false,
      create: false,
      edit: false
    }
  };
  displayedColumns: string[] = ['name', 'programFee', 'location', 'startDate', 'endDate', 'isActive'];

  constructor(
     private _router: Router,
     private _snackBar: MatSnackBar,
     private _fetchData: FetchData,
     private _getSalesforceDataService: GetSalesforceDataService
   ) {}

     ngOnInit(): void {
    const { countAdmin, countStaff, lstStaffData } = this._fetchData.data;

    if (countAdmin === 1) {
      this.isAdmin = true;
      this.permissions.programs = { view: true, create: true, edit: true }; // Admin has all permissions
      this.getProgramsForAdmin();
    }

    if (countAdmin === 0 && countStaff === 1 && lstStaffData && lstStaffData.length > 0) {
      this.isAdmin = false;
      this.parseStaffPermissions(lstStaffData[0].Permission_Sets__c);
      this.getProgramsForStaff();
    }

    // Update displayed columns based on permissions
    if (this.canEdit()) {
      this.displayedColumns.push('actions');
    }
  }

  private parseStaffPermissions(permissionSets: string): void {
    if (!permissionSets) return;

    try {
      // Replace HTML-encoded quotes and parse JSON
      const decodedPermissions = permissionSets.replace(/&quot;/g, '"');
      const permissions = JSON.parse(decodedPermissions);
      
      if (permissions.programs) {
        this.permissions.programs = {
          view: permissions.programs.view || false,
          create: permissions.programs.create || false,
          edit: permissions.programs.edit || false
        };
      }
    } catch (error) {
      console.error('Error parsing permissions:', error);
    }
  }

  canView(): boolean {
    return this.isAdmin || this.permissions.programs.view;
  }

  canCreate(): boolean {
    return this.isAdmin || this.permissions.programs.create;
  }

  canEdit(): boolean {
    return this.isAdmin || this.permissions.programs.edit;
  }
  getProgramsForAdmin(): void {
    const programList = this._fetchData.data?.lstPrograms;
    const locationList = this._fetchData.data?.lstLocations;
    const adminList = this._fetchData.data?.lstAdministratorData;

    if (programList && Array.isArray(programList) && adminList && adminList.length > 0) {
      const adminId = adminList[0].Id;

      this.dataSource = programList
        .filter(program => program.Administrator__c === adminId)
        .map((program) => {
          const location = locationList?.find(loc => loc.Id === program.Program_Location__c);
          return {
            ...program,
            Program_Location__c: location?.Name || program.Program_Location__c || ''
          };
        });

    } else {
      this._snackBar.open('No programs found or failed to fetch programs.', 'Close', {
        duration: 3000
      });
    }
  }

getProgramsForStaff(): void {
  const dataSet = this._fetchData.data;
  const programList = dataSet?.lstPrograms;
  const locationList = dataSet?.lstLocations;
  const staffList = dataSet?.lstStaffData;

  if (programList && Array.isArray(programList) && staffList && staffList.length > 0) {
    const staffAdminIds = staffList
      .map(staff => staff.Administrator__c)
      .filter(adminId => !!adminId);

    this.dataSource = programList
      .filter(program => staffAdminIds.includes(program.Administrator__c))
      .map(program => {
        const location = locationList?.find(loc => loc.Id === program.Program_Location__c);
        return {
          ...program,
          Program_Location__c: location?.Name || program.Program_Location__c || ''
        };
      });

  } else {
    this._snackBar.open('No programs found or failed to fetch programs.', 'Close', {
      duration: 3000
    });
  }
}

  goToProgramDetail(programId: string): void {
    if (programId) {
      this._router.navigate(['/program-detail', programId]);
    } else {
      this._snackBar.open('Program ID is missing.', 'Close', {
        duration: 3000
      });
    }
  }
  editProgram(program: any): void {
    if (program?.Id) {
      this._router.navigate(['/create-program', program.Id], {
        state: { programData: program }
      });
    } else {
      this._snackBar.open('Program data is incomplete', 'Close', {
        duration: 3000
      });
    }
  }
}
